import React, { Component } from "react";
import SquareIcon from "./squareIcon";
import FilterPannel from "./FilterPannel";
import axios from "axios";
import "../App.css";
class mainPane extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      fullData: [],
    };
  }

  componentDidMount() {
    axios
      .get(`${process.env.PUBLIC_URL}/data.json`)
      .then((res) => {
        let data = res.data.data;
        this.setState({ data: data });
        this.setState({ fullData: data });
      })
      .catch((err) => console.log(err.data));
  }

  filterfun = (obj) => {
    const { fullData } = this.state;
    let keywords = obj.map((elem) => elem.value);
    let filteredData = [];

    fullData.forEach((item) => {
      for (let i = 0; i < keywords.length; i++) {
        if (item.tag.includes(keywords[i])) {
          filteredData.push(item);
          break;
        }
      }
    });

    if (filteredData.length === 0) {
      this.setState({ data: fullData });
    } else {
      this.setState({ data: filteredData });
    }
  };

  render() {
    const { data } = this.state;
    return (
      <>
        <section className="section">
          <div className="container">
            {/* <FontAwesome name="users" style={{ color: "blue" }} > </FontAwesome> &nbsp; <p style={{ display: "inline", color: "blue" }}> For Organizations </p> */}
            <br /> <br />
            <div className="columns reverse-columns">
              <div className="column is-9">
                <div className="content is-medium">
                  <SquareIcon val={data} />
                </div>{" "}
              </div>
              <div className="column is-3">
                <aside className="is-medium menu">
                  <div className="has-text-centered">
                    <b> Filters </b>
                  </div>
                  <br />
                  <FilterPannel val={data} filterfun={this.filterfun} />
                </aside>
              </div>
            </div>
          </div>
        </section>
        <section className="columns section">
          <div className="column  is-12 has-text-centered">
            <a
              className="hyperlink"
              href="https://www.jetbrains.com/company/customers/experience/CodeOps/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read the CodeOps' Space Customer Story
            </a>
          </div>
        </section>
      </>
    );
  }
}

export default mainPane;
